import { Link, useNavigate } from 'react-router-dom';
import { cacheAka, clearRequest, ErrorMessage, errorReceived, formData, readAkaCache, responseData, setErrorReceived, setLicenseCountry, setLicenseNumber, setLicenseState, getErrorMessage } from '../../utils/data';
import { useEffect, useState } from 'react';
import PrintPage from '../PrintPage';
import Loading from '../Loading';
import { useAuth } from '../../context/AuthContext';
import AddressTable from '../tables/addressTable';
import AliasTable from '../tables/aliasTable';
import EndorsementsTable from '../tables/endorsementsTable';
import MedicalCertTable from '../tables/medcertTable';
import RestrictionTable from '../tables/restrictionsTable';
import PermitTables from '../tables/permitTable';
import HazmatTable from '../tables/hazmatTable';

import "../print.css"
import { createLog } from '../datawriter/createLog';

function AkaResponse() {
    //const testData = data.Response.DriverDetails;
    
    const [testData, setTestData] = useState({});
    const [loading, setLoading] = useState(true);
    const [requestID, setRequestID] = useState('')
    const [errorMessage, setErrorMessage] = useState([]);
    const navigate = useNavigate();
    const { token, email } = useAuth();
    const akaKey = `${formData.Body.DriverRequest.DriverData.DriverDOB}/${formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}`;
    useEffect(() => {
        const fetchData = async () => {
            const cached = readAkaCache(akaKey);
            if (cached) {
              setErrorMessage(cached.messages);
              setTestData(cached.response);
              setRequestID(cached.transactionID);
              setLoading(false);
              return;
            }
            try {
            await responseData('/api/aka', token)
            .then(function (response) {
                createLog(response,email);
                if(response?.Response?.DriverDetails !== undefined) {
                    setErrorMessage(response.Messages)
                    // if(response.Response.DriverDetails.length === 1){
                    //     setLicenseNumber(response.Response.DriverDetails[0].License.LicenseNumber);
                    //     setLicenseState(response.Response.DriverDetails[0].License.JurisdictionOfIssue.toUpperCase());
                    //     navigate('/historyresults', { state: { from: 'aka' } })
                    //     return
                    // }
                    setTestData(response);                    
                    console.log("Completed:",response);
                    setRequestID(response.TransactionGUID);
                    cacheAka({ key: akaKey, response });
                    setLoading(false);
                } else {
                    setErrorReceived(response.Messages.length > 0 ? response.Messages : ["Database Unavailable"]);
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error(error);
                setErrorReceived([getErrorMessage(error, 'Unable to retrieve AKA information. Please try again.')]);
                navigate(-1);
            })
            
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived([getErrorMessage(error, 'Unable to retrieve AKA information. Please try again.')]);
            navigate(-1);
          }
          
        };
    
        fetchData();
    }, []);
    
    function navHistory(e, license, state) {
        e.preventDefault();
        setLicenseCountry("US");
        setLicenseNumber(license);
        setLicenseState(state.toUpperCase());
        navigate('/historyresults', { state: { fromAkaMinimal: true, licenseOnly: true } })
    }
    if(loading){
        return(<>
            <Loading />
            </>)  
    }
    if(testData.Response.DriverDetails.PersonDetails){
        console.log("Test data update for 1 response: ", testData)
        return(
            <>
            <div id='print-area'>
            {errorMessage.map((message => (
                <ErrorMessage value={message} />
            )))}
            <div className="table-responsive-sm" id='table'>
                <div style={{ fontSize: 'small', width: 'fit-content', background: 'white' }}>
                <div id="banner-results">
                    <h4>AKA Lookup Search Results</h4>
                    <h6>
                        <span>/{formData.Body.DriverRequest.DriverData.DriverDOB}/{formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}</span>
                        <span style={{float: 'right' }}>{requestID}</span>
                    </h6>
                </div>
                    <th>Driver General Information</th>
                <table className="table table-striped table-bordered">
                
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.FirstName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.MiddleName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.SurName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.Suffix}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">SSN</th>
                        <th scope="col">Date of Birth</th>
                        <th scope="col">Height</th>
                        <th scope="col">Weight</th>
                        <th scope="col">Eye Color</th>
                        <th scope="col">Sex</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.SSN}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.DOB}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Height}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Weight}</td>
                        {testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1] ? <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1]}</td>: <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor}</td>}
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Sex}</td>
                    </tr>
                </tbody>
            </table>
                <div>
                    
                    <AddressTable label="Residence Address" address={testData.Response.DriverDetails.PersonDetails.ResidenceAddress}/>
                    <AddressTable label="Mailing Address" address={testData.Response.DriverDetails.PersonDetails.MailingAddress}/>
                    <AliasTable alias={testData.Response.DriverDetails.Alias}/>
                </div>
                <th>Driver License Details</th>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Jurisdiction</th>
                            <th scope="col">Driver License</th>
                            <th scope="col">Issue Date</th>
                            <th scope="col">Expiration Date</th>
                            <th scope="col">Commercial Class Code</th>
                            <th scope="col">Commercial Status</th>
                            <th scope="col">Non Commercial Class</th>
                            <th scope="col">Non Commercial Status Code</th>
                            <th scope="col">Withdrawal Action Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{testData.Response.DriverDetails.License.JurisdictionOfIssue}</td>
                            <td>{testData.Response.DriverDetails.License.LicenseNumber}</td>
                            <td>{testData.Response.DriverDetails.License.IssueDate}</td>
                            <td>{testData.Response.DriverDetails.License.ExpirationDate ?? testData.Response.DriverDetails.License.ExpiryDate}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.WithdrawalActionPending.split('-')[1]}</td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <EndorsementsTable endorsements={testData.Response.DriverDetails.Endorsements}/>
                    <CheckHazmat hazmat={testData.Response.DriverDetails.Endorsements} />
                    <MedicalCertTable medCert={testData.Response.DriverDetails.MedicalCertificate}
                    medName={testData.Response.DriverDetails.MedicalExaminerName}
                    med={testData.Response.DriverDetails.MedicalExaminer}
                    medRest={testData.Response.DriverDetails.MedicalCertificateRestrictionCode}/>
                    <RestrictionTable restrictions={testData.Response.DriverDetails.Restrictions}/>
                    <PermitTables permits={testData.Response.DriverDetails.Permits}/>
                    
                </div>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Convictions</th>
                        <th scope="col">Accidents</th>
                        <th scope="col">Withdrawals</th>
                        <th scope="col">Permits</th>
                        <th scope="col">License Restrictions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord ? <td>{testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.TotalAccidentsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalAccidentsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.NumberOfPermits ? <td>{testData.Response.DriverDetails.License.NumberOfPermits}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.NumberOfRestrictions ? <td>{testData.Response.DriverDetails.License.NumberOfRestrictions}</td> : <td>0</td>}
                    </tr>
                </tbody>
            </table>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Central Site MPR Creation Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.RecordCreationDate}</td>
                    </tr>
                </tbody>
            </table>
                </div>
            </div><div style={{ display: 'flex', gap: '0.5rem' }}>
                    <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
                    <PrintPage
                    type="aka"
                    response={testData.Response}
                    queryLine={`/${formData.Body.DriverRequest.DriverData.DriverDOB}/${formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}`}
                    transactionID={requestID}
                    messages={errorMessage}
                    />
                </div>
                </div>
                </>
        )
    }
    return(
        <>
        <div id='print-area'>
        {errorMessage.map((message => (
            <ErrorMessage value={message} />
        )))}
        {errorReceived.length > 0 && (
            <div className="alert alert-danger" role="alert">
                {errorReceived.map((err, index) => (
                    <span key={index}>{err}</span>
                ))}
            </div>
        )}
        <div id='table' style={{minWidth:'85%'}}>
            <div id="banner-results">
                <h4>AKA Lookup Search Results</h4>
                <h6>
                    <span>/{formData.Body.DriverRequest.DriverData.DriverDOB}/{formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}</span>
                    <span style={{float: 'right' }}>{requestID}</span>
                </h6>
            </div>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">State</th>
                        <th scope="col">Driver License</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Date of Birth</th>
                        <th scope="col">Central Site MPR Creation Date</th>
                    </tr>
                </thead>
                <tbody>
                    {testData.Response.DriverDetails.map(details => (
                        <tr>
                            <td>{details.License.JurisdictionOfIssue}</td>
                            <td>
                                <Link href="/historyresults" onClick={(e) => navHistory(e, details.License.LicenseNumber, details.License.JurisdictionOfIssue)}>{details.License.LicenseNumber}</Link>
                            </td>
                            <td>{details.PersonDetails.PersonName.FirstName}</td>
                            <td>{details.PersonDetails.PersonName.MiddleName}</td>
                            <td>{details.PersonDetails.PersonName.SurName}</td>
                            <td>{details.PersonDetails.DOB}</td>
                            <td>{details.PersonDetails.RecordCreationDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div><div>
        <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
        </div>
        </div>
            </>
    );
}

function CheckHazmat({hazmat}){
    if(hazmat  !== undefined && hazmat !== null && hazmat !== '' && hazmat.length !== 0){
         return(
         <HazmatTable hazmat={hazmat.Endorsements}/>
         )
    }
}

export default AkaResponse;